

const __request = require(`./__request/__request_contentType_json`);

// 火车票订单更新保险状态接口地址：http://219.128.52.2:9901/doc.html#/trains/platform-order-controller/getPlatformOrderListUsingPOST

export default function trains_order_updateInsuranceStatus(pParameter) {
  if (!pParameter) pParameter = {};
  let params = {}
  params.method = 'POST'
  params.urlSuffix = '/trains/order/updateInsuranceStatus'
  params.data = pParameter;
  params.process_response_data = false
  return new Promise(function (resolve, reject) {
    resolve(__request(params))
  })
}
